<template>
  <div>
    <wc-data-box
      title='Quote'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
      :loading='isLoading'
    >
      <v-card-text class='text-center'>
        <h1 class='display-1 font-weight-light info--text'>{{ estimate.amount | decMoney }}</h1>
      </v-card-text>
    </wc-data-box>
    <wc-dialog
      :showDialog='showEditDialog'
      title='Quote Amount'
      :icon='icon'
      :iconColor='iconColor'
      width='350'
      :disableButtons='!isFormValid'
      @cancel='cancelEdit'
      @save='saveAmount'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          ref='amount'
          :rules='[rules.decimal]'
          prepend-icon='mdi-currency-usd'
          reverse
          v-model='estimateCopy.amount'
          id='amount'
        ></v-text-field>
        <v-card-text v-if='estimate.estimate_type == "ST"' class='caption'>System Takeover - Be sure to include any cost for travel time in the quote amount</v-card-text>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'estimate-amount',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showEditDialog: false,
    icon: 'mdi-currency-usd',
    iconColor: 'success',
    estimateCopy: {}
  }),
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showEditDialog = true
      setTimeout(() => {
        document.getElementById('amount').select()
      }, 100)
    },
    cancelEdit () {
      this.showEditDialog = false
    },
    saveAmount () {
      this.isLoading = true
      this.$emit('update', this.estimateCopy)
      this.showEditDialog = false
      this.isLoading = false
    }
  }
}
</script>
